import React, { useEffect, useRef, useState } from "react";
import { Link, useParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
import {
  Breadcrumb,
  Table,
  Input,
  Select,
  Form,
  Tooltip,
  Col,
  Spin,
  Radio,
  Row,
} from "antd";
import ButtonField from "../../common/htmlComponents/ButtonField";
import { Collapse } from "antd";
import { getRequest, postRequest } from "../../axios";
import { authUserData } from "../../utils/Helper";
import {
  ErrorNotificationMsg,
  SuccessNotificationMsg,
} from "../../utils/Notifications";
import { useNavigate } from "react-router-dom";
import PurchaseRequisitionSites from "./PurchaseRequisitionSites";
import PropTypes from "prop-types";
import { InfoCircleOutlined } from "@ant-design/icons";
const { Panel } = Collapse;

export const SPECIFIC_GRAVITY = {
  GI: 7.85,
  MS: 7.85,
  CU: 8.96,
  AL: 2.7,
  SS: 8.0,
};

export function getDensity(material) {
  const sg = SPECIFIC_GRAVITY[material.toUpperCase()] || 0;
  return sg * 1000;
}

export function getKgPerMeter(widthMM, thicknessMM, material) {
  const density = getDensity(material);
  const widthM = widthMM / 1000;
  const thicknessM = thicknessMM / 1000;
  const lengthM = 1; 

  const volume = widthM * thicknessM * lengthM;
  return density * volume;
}

const PRPopUpDetails = ({ statePRDetails, categoryTree }) => {
  const [siteName, setSiteName] = useState([]);
  const navigate = useNavigate();
  const { Option } = Select;
  const [pincodeList, setPincodeList] = useState([]);
  // const [loading, setLoading] = useState(false);
  const CompanyID = authUserData()?.company ? authUserData()?.company : null;
  const [subCategoryList, setSubCategoryList] = useState([]);
  const [btnLoading, setBtnLoading] = useState(false);
  const [btnLoading2, setBtnLoading2] = useState(false);
  const [view, setView] = useState("");
  // const [loading, setLoading] = useState(false);
  const { t } = useTranslation();
  const { id, prId } = useParams();
  const formRef = useRef();
  const [selectedCategoryName, setSelectedCategoryName] = useState("");
  const [estimatedValueFromApi, setEstimatedValueFromApi] = useState([
    {
      id: "",
      value: "",
    },
  ]);
  const [totalAmountPr, setTotalAmountPr] = useState(0);
  const [disabled, setDisabled] = useState(true);
  const [tableData, setTableData] = useState([]);

  const [stateWBS, setStateWBS] = useState([]);

  
  const [siteWiseTotalAmount, setSiteWiseTotalAmount] = useState({
    siteName: "",
    total: "",
  });

  const [siteTotalQuantities, setSiteTotalQuantities] = useState([]);
  const [subCategoryData, setSubCategoryData] = useState([]);
  const [cityLength, setCityLength] = useState(1);
  const [currencySymbol, setCurrencySymbol] = useState("₹");
  const [apiLoading, setapiLoading] = useState(false);
  const [viewOption, setViewOption] = useState(false);
  const [prView, setPRView] = useState(null);

  const [overallTotal, setOverallTotal] = useState(0);
 
  useEffect(() => {
    getCurrency();
    getUnitOfMeasurement();
  }, [id, prId]);

  let updateTableData = [];

  updateTableData = (state) => {
    const tableData = [];
    const length = statePRDetails?.length;
    setSelectedCategoryName(categoryTree);
    setCityLength(length);
    let totalCityOfAllSite = 0;
    statePRDetails?.forEach((city, cityIndex) => {
      const cityRowSpan = city.site_wise_pr.length;
      let cityTotalQuantity = 0;
      let cityTotalQuantityByKg = 0;
      let cityTotal = 0;
      let cityAmount = 0;

      city.site_wise_pr.forEach((site, siteIndex) => {
        let siteTotalQuantity = 0;
        let siteTotalQuantityForKG = 0;
        let siteMaterialTotal = 0;
        site.site_total_quantity += siteTotalQuantity;
        let siteAmount = 0;
        site.pr_material_details?.forEach((material) => {
          siteTotalQuantity += material.pr_material_type_quantity;
          siteMaterialTotal += material.pr_material_type_quantity * 105;
          siteTotalQuantityForKG += material.pr_material_type_quantity_by_kg;
          if (material.pr_material_type_uom_name === "Cubic Meter") {
            siteAmount +=
              material.pr_material_type_quantity *
              material.estimated_material_unit_price;
          } else if (
            material.pr_material_type_sub_category?.includes("Earthing")
          ) {
            siteAmount += material.estimated_amount;
          } else {
            siteAmount +=
              material.pr_material_type_quantity_by_kg *
              material.estimated_material_unit_price;
          }
        });
        site.site_total_quantity = siteTotalQuantity;
        setSiteTotalQuantities((prevQuantities) => [
          ...prevQuantities,
          siteTotalQuantity,
        ]);

        cityTotalQuantity += siteTotalQuantity;
        cityTotal += siteMaterialTotal;
        cityTotalQuantityByKg += siteTotalQuantityForKG;
        cityAmount += siteAmount;
        totalCityOfAllSite += siteAmount;

        tableData.push({
          key: `${cityIndex}-${siteIndex}`,
          srNo:
            length > 1
              ? siteIndex === 0
                ? cityIndex + 1
                : null
              : siteIndex + 1,
          cityName: siteIndex === 0 ? city.city_name : null,
          cityRowSpan: siteIndex === 0 ? cityRowSpan : 0,
          siteName: site.site_name,
          siteLocations: site.pr_material_details?.map((material, matIndex) => {
            return {
              availableBudget: material.available_budget || 0,
              estimatedPRValue: material.estimated_material_unit_price || 0,
              remark: material.remark,
              materialName: material.pr_material_type_name,
              quantity: material.pr_material_type_quantity,
              quantityForKG: material.pr_material_type_quantity_by_kg,
              uom: material.pr_material_type_uom_id,
              uom_name: material.pr_material_type_uom_name,
              subCategory: material.pr_material_type_sub_category,
              siteIndex,
              matIndex,
              cityId: city.city_name,
              siteId: site.pr_site_id,
              estimatedPrice: material.estimated_material_unit_price,
              amount:
                material.pr_material_type_uom_name === "Cubic Meter"
                  ? material.pr_material_type_quantity *
                    material.estimated_material_unit_price
                  : material.pr_material_type_quantity_by_kg *
                    material.estimated_material_unit_price,
            };
          }),
          totalAmount: (
            <Input
              disabled
              className="site-subtotal"
            />
          ),
        });

        tableData.push({
          key: `${cityIndex}-${siteIndex}-SiteSubTotal`,
          siteName: "Site Sub-Total",
          siteLocations: [
            {
              totalQuantity: siteMaterialTotal,
              materialName: "",
              quantity: siteTotalQuantity,
              quantityForKG: siteTotalQuantityForKG,
              subCategory: "",
              siteIndex,
              matIndex: 0,
              cityId: city.city_id,
              siteId: site.site_id,
              amount: siteAmount,
            },
          ],
          totalAmount: (
            <Input
              disabled
              value={`\u20B9 ${siteTotalQuantity || 0}`}
              className="site-subtotal"
            />
          ),
          siteTotalQuantity: (
            <Input
              disabled
              value={siteTotalQuantity || 0}
              className="site-total-quantity"
              readOnly
            />
          ),
        });

        if (length > 1) {
          if (siteIndex === city.site_wise_pr.length - 1) {
            tableData.push({
              key: `${cityIndex}-${siteIndex}-CityTotal`,
              siteName: "City Total",
              siteLocations: [
                {
                  materialName: "",
                  cityTotal: cityTotal,
                  quantity: cityTotalQuantity,
                  quantityForKG: cityTotalQuantityByKg,
                  subCategory: "",
                  siteIndex,
                  matIndex: 0,
                  cityId: city.city_id,
                  siteId: site.site_id,
                  amount: cityAmount,
                },
              ],
              totalAmount: (
                <Input
                  disabled
                  value={`\u20B9 ${cityTotalQuantity || 0}`}
                  className="subtotal"
                  readOnly
                />
              ),
              cityTotalQuantity: (
                <Input
                  disabled
                  value={city.city_total_quantity || 0}
                  className="city-total-quantity"
                  readOnly
                />
              ),
            });
          }
        }
      });

      city.city_total_quantity = cityTotal;
    });
    let totalAmount;
    let totalQuantity;
    tableData.push({
      key: `Total`,
      siteName: `Est. Total`,
      siteName1: "Total",
      siteLocations: [
        {
          materialName: "",
          cityTotal: "",
          quantity: "",
          totalCityOverallSite: totalCityOfAllSite,
          cityQuantityForKG: "",
          cityTotalAmountForKG: "",
          subCategory: "",
          siteIndex: 0,
          matIndex: 0,
        },
      ],
      totalAmount: <Input disabled value="₹ 0" className="subtotal" readOnly />,
      totalQuantity: (
        <Input disabled value="0" className="city-total-quantity" readOnly />
      ),
    });
    setTableData(tableData);
  };


  useEffect(() => {
    updateTableData(statePRDetails);
  }, [statePRDetails]);

  const getUnitOfMeasurement = async (data) => {
    await getRequest("get-category-by-uom/?category_tree", data).then(
      (response) => {
        setPincodeList(response.data.results.data);
      }
    );
  };


  

  const getCurrency = async (data) => {
    await getRequest(
      "business-settings/get-currency-by-business-setting/",
      data
    ).then((response) => {
      setCurrencySymbol(response.data.data);
    });
  };

  const parseEarthingStrip = (name) => {
    const match = name.match(/(\d+)\s*x\s*(\d+)\s*[-–]\s*(\w+)/i);
    if (!match) return null;
    return {
      width: parseFloat(match[1]),
      thickness: parseFloat(match[2]),
      material: match[3].toUpperCase(), 
    };
  };
  const columns = [
    {
      title: "Sr.",
      dataIndex: "srNo",
      fixed: "left",
      width: 50,
    },
    {
      title: "Site",
      dataIndex: "siteName",
      key: "siteName",
      fixed: "left",
      width: 150,
      render: (siteLocations, record) => {
        if (record.siteName === "Site Sub-Total") {
          return <div className="subtotal">{"Sub total"}</div>;
        } else if (record.siteName === "City Total") {
          return <div className="citytotal">{"City total"}</div>;
        } else if (record.siteName1 === "Total") {
          return (
            <div className="totalCityOverallSite1">
              <Tooltip
                color={colors}
                placement="left"
                title={<span style={{ color: "#fff" }}>Estimated Amount</span>}
              >
                {record.siteName}{" "}
                <InfoCircleOutlined
                  style={{ color: "#094E8F", marginLeft: "3px" }}
                />
              </Tooltip>
            </div>
          );
        } else {
          return <>{record.siteName}</>;
        }
      },
    },
    {
      title: "Item",
      dataIndex: "siteLocations",
      fixed: "left",
      width: 190,
      render: (siteLocations) => (
        <>
          <div
            style={{ display: "flex", flexDirection: "column", gap: "10px" }}
          >
            {siteLocations.map((site, index) => (
              <div key={index} className="lblvalue">
                {site.materialName}
              </div>
            ))}
          </div>
        </>
      ),
    },
    {
      title: "Qty.",
      dataIndex: "siteLocations",
      fixed: "right",
      align: "center",
      width: 80,
      render: (siteLocations, record) => {
        if (record.siteName === "Site Sub-Total") {
          return <></>;
        } else if (record.siteName === "City Total") {
          return <></>;
        } else if (record.siteName1 === "Total") {
          return <></>;
        } else {
          return (
            <>
              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  gap: "10px",
                  marginLeft: "5px",
                }}
              >
                {siteLocations.map((site, index) => (
                  <div key={index} className="lblvalue">
                    {site.quantity}
                  </div>
                ))}
              </div>
            </>
          );
        }
      },
    },
    {
      title: (
        <Tooltip
          color="#094E8F"
          placement="top"
          title={
            <span style={{ color: "#fff" }}>
              Preferred Unit of measurement means Your company buys material
              generally in this unit of measurement
            </span>
          }
        >
          Preferred UoM.
        </Tooltip>
      ),
      width: 130,
      dataIndex: "siteLocations",
      align: "center",
      render: (siteLocations, record) => {
        const defaultOption = pincodeList.find(
          (option) => option.unit_of_measurement === "MT"
        );
        const defaultValue = defaultOption ? defaultOption.id : 1;
        if (
          record.siteName === "City Total" ||
          record.siteName === "Site Sub-Total" ||
          record.siteName === "Total"
        ) {
          return "";
        }
        return (
          <>
            <div
              style={{ display: "flex", flexDirection: "column", gap: "10px" }}
            >
              {siteLocations.map((site, index) => {
                if (site.subCategory.toLowerCase().includes("earthing")) {
                  return (
                    <div
                      key={index}
                      className="lblvalue"
                      style={{ marginLeft: "5px", textTransform:'capitalize' }}
                    >
                      {site.uom_name}
                    </div>
                  );
                } else if (site.uom_name === "Cubic Meter") {
                  return (
                    <div
                      key={index}
                      className="lblvalue"
                      style={{ marginLeft: "5px" }}
                    >
                      Cu. Mtr.
                    </div>
                  );
                } else {
                  return (
                    <div
                      key={index}
                      className="lblvalue"
                      style={{ marginLeft: "5px" }}
                    >
                      {site.uom_name}
                    </div>
                  );
                }
              })}
            </div>
          </>
        );
      },
    },
    !selectedCategoryName === "Earthing" && {
      title: "Qty. In Kg",
      dataIndex: "siteLocations",
      width: 130,
      align: "right",
      render: (siteLocations, record) => {
        if (record.siteName === "Site Sub-Total") {
          // return (
          //   <>
          //   </>
          // );
        } else if (record.siteName === "City Total") {
          // return (
          //   <>
          //   </>
          // );
        } else if (record.siteName === "Total") {
          //   return <></>;
        } else {
          return (
            <>
              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  gap: "10px",
                  float: "inline-end",
                  //marginLeft: "5px"
                  marginRight: "5px",
                }}
              >
                {siteLocations.map((site, index) => {
                  return (
                    <div key={index} className="">
                      {site?.quantityForKG == 0
                        ? "-"
                        : site?.quantityForKG?.toLocaleString("en-IN", {
                            maximumFractionDigits: 0,
                          })}
                    </div>
                  );
                })}
              </div>
            </>
          );
        }
      },
    },
    !selectedCategoryName === "Earthing" && {
      title: (
        <Tooltip
          title="Reference price of estimated unit rate comes from material master data"
          color="#094E8F"
          placement="top"
        >
          <span>Est. Unit rate</span>
        </Tooltip>
      ),
      dataIndex: "siteLocations",
      width: 140,
      align: "right",
      render: (siteLocations, record) => {
        if (
          record.siteName !== "Site Sub-Total" &&
          record.siteName !== "Est. Total" &&
          record.siteName !== "City Total"
        ) {
          return (
            <>
              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  gap: "10px",
                }}
              >
                {siteLocations.map((site, index) => (
                  <div
                    key={index}
                    className="lblvalue"
                    style={{ display: "flex", justifyContent: "flex-end" }}
                  >
                    ₹ {site.estimatedPrice}{" "}
                    {site.subCategory === "RMC" ? "/ Cu. Mtr." : "/ Kg"}
                  </div>
                ))}
              </div>
            </>
          );
        }
      },
    },

    selectedCategoryName === "Earthing" && {
      title: "Est. Unit Rate",
      width: 140,
      align: "right",
      render: (_, record) => {
        if (
          record.siteName1 === "Site Sub Total" ||
          record.siteName1 === "City Total" ||
          record.siteName1 === "Total"
        ) {
          return null;
        }

        return (
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              gap: "10px",
              alignItems: "flex-end",
            }}
          >
            {record.siteLocations.map((site, idx) => {
              if (!site.materialName) return null;

              const isEarthing = site.subCategory
                ?.toLowerCase()
                .includes("earthing");

              if (isEarthing) {
                const parsed = parseEarthingStrip(site.materialName);
                if (parsed) {
                  const kgPerMeter = getKgPerMeter(
                    parsed.width,
                    parsed.thickness,
                    parsed.material
                  );
                  const ratePerKg =
                    site.estimated_price || site.estimatedPrice || 0;
                  const ratePerMeter = kgPerMeter * ratePerKg;

                  const supplierProfitPercent = 10;
                  const res = ratePerMeter * (1 + supplierProfitPercent / 100);

                  return (
                    <div
                      key={idx}
                      style={{ fontWeight: 500, color: "#d4380d" }}
                    >
                      ₹{" "}
                      {res?.toLocaleString("en-IN", {
                        maximumFractionDigits: 0,
                      })}{" "}
                      / M
                    </div>
                  );
                }
              }
              return (
                <div key={idx}>
                  ₹ {site.estimated_price}{" "}
                  {site.uom_name === "MT" ? "/MT" : "/Kg"}
                </div>
              );
            })}
          </div>
        );
      },
    },
    selectedCategoryName !== "Earthing" && {
      title: "Est. Amount",
      dataIndex: "amount",
      key: "amount",
      width: 150,
      align: "right",

      render: (text, record) => {
        if (record.siteName === "Site Sub-Total") {
          if (record.siteLocations && Array.isArray(record.siteLocations)) {
            return (
              <div
                className="subtotal"
                style={{
                  display: "flex",
                  flexDirection: "column",
                  gap: "10px",
                  float: "inline-end",
                }}
              >
                {record.siteLocations.map((site, index) => {
                  return (
                    <div key={index} className="">
                      ₹{" "}
                      {site.amount
                        ? site.amount?.toLocaleString("en-IN", {
                            maximumFractionDigits: 0,
                          })
                        : 0}
                    </div>
                  );
                })}
              </div>
            );
          }
        } else if (record.siteName === "City Total") {
          if (record.siteLocations && Array.isArray(record.siteLocations)) {
            return (
              <div
                className="citytotal"
                style={{
                  display: "flex",
                  flexDirection: "column",
                  gap: "10px",
                  float: "inline-end",
                }}
              >
                {record.siteLocations.map((site, index) => {
                  return (
                    <div key={index} className="">
                      ₹{" "}
                      {site.amount
                        ? site.amount?.toLocaleString("en-IN", {
                            maximumFractionDigits: 0,
                          })
                        : 0}
                    </div>
                  );
                })}
              </div>
            );
          }
        } else if (record.siteName1 === "Total") {
          if (record.siteLocations && Array.isArray(record.siteLocations)) {
            {
              return (
                <div className="totalCityOverallSite1">
                  ₹{" "}
                  {record.siteLocations[0]?.totalCityOverallSite
                    ? record.siteLocations[0]?.totalCityOverallSite?.toLocaleString(
                        "en-IN",
                        {
                          maximumFractionDigits: 0,
                        }
                      )
                    : 0}
                </div>
              );
            }
          }
        } else {
          if (record.siteLocations && Array.isArray(record.siteLocations)) {
            return (
              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  gap: "10px",
                  alignItems: "flex-end",
                  marginRight: "5px",
                }}
              >
                {record.siteLocations.map((site, index) => {
                  return (
                    <div key={index} className="lblvalue">
                      ₹{" "}
                      {site.amount
                        ? site.amount?.toLocaleString("en-IN", {
                            maximumFractionDigits: 0,
                          })
                        : 0}
                    </div>
                  );
                })}
              </div>
            );
          }
        }
      },
    },
    selectedCategoryName === "Earthing" && {
      title: "Est. Amount",
      width: 170,
      align: "right",
      render: (_, record) => (
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            gap: "10px",
            alignItems: "flex-end",
          }}
        >
          {record.siteLocations.map((site, idx) => {
            if (!site.materialName) {
              if (record.siteName === "Site Sub-Total") {
                return (
                  <div key={`subtotal-site-${record.key}`} className="subtotal">
                    ₹ {site.amount?.toLocaleString("en-IN") || 0}
                  </div>
                );
              }
              if (record.siteName === "City Total") {
                return (
                  <div key={`citytotal-${record.key}`} className="citytotal">
                    ₹ {site.amount?.toLocaleString("en-IN") || 0}
                  </div>
                );
              }
              if (record.siteName1 === "Total") {
               
                return (
                  <div
                    key="grandtotal"
                    className="totalCityOverallSitee5"
                    style={{ fontWeight: "bold" }}
                  >
                    ₹ {site.totalCityOverallSite?.toLocaleString("en-IN") || 0}
                  </div>
                );
              }
              return <div key={`empty-${idx}`} />;
            }

            let amount = 0;

           
            if (site.subCategory?.toLowerCase().includes("earthing")) {
              const profitPercent = 10;
              const parsed = parseEarthingStrip(site.materialName);
              if (parsed) {
                const kgPerMeter = getKgPerMeter(
                  parsed.width,
                  parsed.thickness,
                  parsed.material
                );

                const ratePerKg = site.estimatedPrice || 0;

                const ratePerMeter = kgPerMeter * ratePerKg;

                const finalRatePerMeter =
                  ratePerMeter * (1 + profitPercent / 100);

                amount =
                  (site.quantity || 0) *
                  finalRatePerMeter.toLocaleString("en-IN", {
                    maximumFractionDigits: 0,
                  });
              }
            } else {
              let totalKg = 0;

              if (site.material_type_uom_name === "MT") {
                totalKg = (site.quantity || 0) * 1000;
              } else if (site.material_type_uom_name === "Bag") {
                totalKg = (site.quantity || 0) * 50;
              } else {
                totalKg = site.quantity || 0;
              }

              amount = totalKg * (site.estimated_price || 0);
            }
            return (
              <div key={`amount-${record.key}-${idx}`}>
                ₹ {amount.toLocaleString("en-IN", { maximumFractionDigits: 0 })}
              </div>
            );
          })}
        </div>
      ),
    },
    {
      title: "Remarks",
      dataIndex: "siteLocations",
      // width: 150,
      render: (siteLocations) => (
        <>
          <div
            style={{ display: "flex", flexDirection: "column", gap: "10px" }}
          >
            {siteLocations.map((site, index) => (
              <div key={index} className="lblvalue">
                {site.remark}
              </div>
            ))}
          </div>
        </>
      ),
    },
  ].filter(Boolean);

  if (cityLength > 1) {
    columns.splice(1, 0, {
      title: "City",
      dataIndex: "cityName",
      key: "cityName",
      width: 120,
      render: (text, record, index) => {
        if (index === 0 || record.cityName !== tableData[index - 1].cityName) {
          return <div className="lblvalue">{text}</div>;
        } else {
          return <div className="lblvalue" />;
        }
      },
    });
  }

  const theadPR = <Table columns={columns} />;

  const colors = ["#094E8F"];
  return (
    <>
      {
        <>
          <Table
            header={theadPR}
            loading={apiLoading}
            columns={columns}
            dataSource={tableData}
            pagination={false}
            className="modal-table"
          />
        </>
      }
      
    </>
  );
};

PRPopUpDetails.propTypes = {
  statePRDetails: PropTypes.func,
  categoryTree: PropTypes.func,
};

export default PRPopUpDetails;
